if (!customElements.get('cross-sell-bundles')) {
    class CrossSellBundles extends HTMLElement {
        constructor() {
            super();
            this.bundles = this.querySelectorAll('.cross-sell--bundle');

            this.init();
        }

        init() {
            this.bundles.forEach( (bundle) =>{
                let add_to_cart = bundle.querySelector('.cross-sell--bundle__addToCart');
                let cover = bundle.querySelector('.cross-sell--bundle_cover');

                this.hideBundle(bundle);
                this.checkAmountOfComponents(bundle);

                cover.addEventListener('click', () =>{
                    bundle.classList.toggle('opened-bundle');
                    bundle.querySelector('.cross-sell--bundle_container').classList.toggle('hidden');
                });

                add_to_cart.addEventListener( 'click', (ev)=>{
                    ev.preventDefault();
                    ev.target.setAttribute('disabled', true);
                    ev.target.classList.add('product-add--adding');

                    if(ev.target.classList.contains('bundle-kit')){
                        this.addKitToCart(bundle);
                    }else{
                        this.addBundleToCart(bundle);
                    }
                    ev.target.setAttribute('disabled', false);
                    ev.target.classList.add('product-add--added');
                    ev.target.classList.remove('product-add--adding');
                    ev.target.classList.remove('product-add--added');
                })
            })
        }

        hideBundle(bundle) {
            if(bundle.classList.contains('bundle-kit-block')){
                return
            }

            const components = bundle.querySelectorAll('.component--bundle');
            let aneveliable_components = false;

            if (components.length === 0) {
                aneveliable_components = true;
            }

            components.forEach( (component) => {
                const inventory = parseInt(component.dataset.componentInv, 10) || 0;
                if(inventory < 1) aneveliable_components = true;
                return
            })

            if (aneveliable_components) {
                bundle.style.display = 'none';
            }
        }

        addKitToCart(bundle){
            let formData = {};
            let arr_items = [
                {
                    id: bundle.getAttribute('data-bundle-variant').trim(),
                    quantity: 1
                }];

            formData['items'] = arr_items;
            theme.promo.addToCart(formData);

            this.bundles.forEach( (bundle) => {
                this.checkAmountOfComponents(bundle);
            });
        }

        addBundleToCart(bundle){
            let _this = this,
                arr_items = [],
                formData = {};

            let bundle_components = [];
            let bundle_qty = 1;
            let bundleCoverVariantID = "gid://shopify/ProductVariant/"+ (bundle.getAttribute('data-bundle-variant').trim());
            let bundleNewPrice = bundle.querySelector('.current-price').getAttribute('data-currency-usd').replace('$', '').replace('USD', '').trim();
            let bundleChanges = 'am-'+bundleNewPrice;

            bundle.querySelectorAll('.component--bundle').forEach((component) => {
                bundle_components.push( component.getAttribute('data-component-id'));
            });

            let arr_ids = [...bundle_components];
            arr_ids.sort(function(a, b) {
                return a*1 - b*1;
            });

            let bundleId = "bundle-id";
            arr_ids.forEach(function (el){
                bundleId = bundleId + '-' + el;
            });

            let uniq_components = [];
            let components_count = [];
            for(let i = 0; i < bundle_components.length; i++){
                if(uniq_components.indexOf(bundle_components[i]) === -1){
                    uniq_components.push(bundle_components[i]);
                    let comp_count = _this.getOccurrence(bundle_components, bundle_components[i]);
                    components_count.push(comp_count);
                }
            }

            for(let i = 0; i < uniq_components.length; i++){
                let item = {
                    id: uniq_components[i],
                    quantity: bundle_qty * components_count[i],
                    properties: {
                        _bundle_uniq_id: bundleId,
                        _bundle_cover: bundleCoverVariantID,
                        _bundle_changes: bundleChanges,
                        _bundle_type: "Cross-sell",
                        _bundle_qty_per: components_count[i],
                    }
                }

                arr_items.push(item);
            }

            formData['items'] = arr_items;
            theme.promo.addToCart(formData);

            setTimeout(()=>{
                this.bundles.forEach( (bundle) => {
                    this.checkAmountOfComponents(bundle);
                });
            }, 3000)

        }

        getOccurrence(array, value) {
            var count = 0;
            array.forEach((v) => (v === value && count++));
            return count;
        }

        checkAmountOfComponents(bundle) {
            const bundleContainer = bundle.querySelector('.cross-sell--bundle_container');

            if (!bundleContainer) {
                return;
            }

            const addToCartButton = bundleContainer.querySelector('.cross-sell--bundle__addToCart');
            const activeVariants = bundle.querySelectorAll('.color-swatch.active');
            const cartJsonElement = document.querySelector('#LimitedCartJson');

            if (!addToCartButton || activeVariants.length === 0) {
                return;
            }

            let cartQuantities = {};
            if (cartJsonElement) {
                try {
                    const cartData = JSON.parse(cartJsonElement.innerHTML);
                    cartData.items.forEach(item => {
                        if (item.components) {
                            item.components.forEach(component => {
                                cartQuantities[component.id] = (cartQuantities[component.id] || 0) + component.quantity;
                            });
                        } else {
                            cartQuantities[item.id] = (cartQuantities[item.id] || 0) + item.quantity;
                        }
                    });
                } catch (e) {
                    return;
                }
            }

            let unavailableVariantsCount = 0;

            activeVariants.forEach(variant => {
                const variantId = variant.dataset.variantId;
                const variantInv = parseInt(variant.dataset.variantInv, 10) || 0;

                if (variantInv < 1) {
                    unavailableVariantsCount++;
                    return;
                }

                const quantityInCart = cartQuantities[variantId] || 0;
                if (variantInv - quantityInCart < 1) {
                    unavailableVariantsCount++;
                }
            });

            const shouldBeDisabled = unavailableVariantsCount > 0;
            addToCartButton.disabled = shouldBeDisabled;
        }

    }

    customElements.define('cross-sell-bundles', CrossSellBundles);
}